module.exports = __webpack_public_path__ + "img/3.ecb15ec7.png";